<script>
    import RadioButton from '../RadioButton.svelte';
    import { onMount } from 'svelte';
    export let item;

    const setPortability = (value) => {
        item.portability = value;
    };

    onMount(() => {
        setPortability(item.portability === 'N' ? 'N' : 'Y');
    });
</script>

<h3 class="title text-fs-15 fw-semibold">
    Selecciona la portabilidad Línea {item.index}
</h3>
<div class="pure-g">
    <div class="pure-u-2-5">
        <RadioButton
            id="portabilityYes-{item.index}-{item.plan.extId}"
            name="portability-{item.index}-{item.plan.extId}"
            label="Quiero conservar mi número"
            checked={item.portability === 'Y'}
            changeHandler={() => {
                setPortability('Y');
            }}
        />
        <p class="text-fs-13">
            Recibirás un correo electrónico con las instrucciones para portar tu
            número telefónico
        </p>
    </div>
    <div class="pure-u-2-5 pure-u-lg-offset-1-6">
        <RadioButton
            id="portabilityNo-{item.index}-{item.plan.extId}"
            name="portability-{item.index}-{item.plan.extId}"
            label="No quiero conservar mi número"
            checked={item.portability === 'N'}
            changeHandler={() => {
                setPortability('N');
            }}
        />
        <p class="text-fs-13">
            Tu nuevo número telefónico se asignará después de activar la SIM
            izzi móvil
        </p>
    </div>
</div>
